A privacy consent component of an `ApplicationQuestionnaire`.

This must be provided if the `componentTypeCode` is `PrivacyConsent`.
